/*
 *
 * CoursesDetail actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the course, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COURSES */

export function loadCourse(id) {
  return {
    type: LOAD_COURSE,
    id,
  };
}

/**
 * Dispatched when the loadCourse are loaded by the request saga
 *
 * @param  {array} Course true for course
 *
 * @return {object}      An action object with a type of LOAD_COURSES_SUCCESS passing the course */

export function loadCourseSuccess(itemData) {
  return {
    type: LOAD_COURSE_SUCCESS,
    itemData,
  };
}

/**
 * Dispatched when loading the loadCourses fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COURSES_ERROR passing the error */

export function loadCourseError(error) {
  return {
    type: LOAD_COURSE_ERROR,
    error,
  };
}